import(/* webpackMode: "eager" */ "/my-first-project/app/globals.css");
import(/* webpackMode: "eager" */ "/my-first-project/components/sentry-provider.tsx");
import(/* webpackMode: "eager" */ "/my-first-project/components/theme-provider.tsx");
import(/* webpackMode: "eager" */ "/my-first-project/components/ui/toaster.tsx");
import(/* webpackMode: "eager" */ "/my-first-project/components/ui/tooltip.tsx")